import {
  fetchTicketLoading,
  fetchTicketSuccess,
  fetchTicketFail,
  searchTickets,
  fetchSingleTicketLoading,
  fetchSingleTicketSuccess,
  fetchSingleTicketFail,
  replyTicketLoading,
  replyTicketSuccess,
  replyTicketFail,
  closeTicketLoading,
  closeTicketSuccess,
  closeTicketFail,
  openTicketLoading,
  openTicketSuccess,
  openTicketFail,
  inProgressTicketLoading,
  inProgressTicketSuccess,
  inProgressTicketFail,
  underReviewTicketLoading,
  underReviewTicketSuccess,
  underReviewTicketFail,
} from "./ticketsSlice";

import {
  getAllTickets,
  getSingleTicket,
  updateReplyTicket,
  updateTicketStatusClosed,
  updateTicketStatusInProgress,
  updateTicketStatusUnderReview,
  updateTicketStatusOpen,
} from "../../api/ticketApi";


export const fetchAllTickets = () => async (dispatch) => {
  dispatch(fetchTicketLoading());
 // const { user } = useSelector((state) => state.user);
  try {
    const result = await getAllTickets();
    console.log(result);
    result.data.result.length &&
      dispatch(fetchTicketSuccess(result.data.result));
  } catch (error) {
    dispatch(fetchTicketFail(error.message));
  }
};

export const filterSerachTicket = (str) => (dispatch) => {
  dispatch(searchTickets(str));
};

//Actions for single ticket only
export const fetchSingleTicket = (_id) => async (dispatch) => {
  dispatch(fetchSingleTicketLoading());
  try {
    const result = await getSingleTicket(_id);
    console.log(result.data.result[0]);
    dispatch(
      fetchSingleTicketSuccess(
        result.data.result.length && result.data.result[0]
      )
    );
  } catch (error) {
    dispatch(fetchSingleTicketFail(error.message));
  }
};

//Actions for replying on single ticket
export const replyOnTicket = (_id, msgObj) => async (dispatch) => {
  dispatch(replyTicketLoading());
  try {
    const result = await updateReplyTicket(_id, msgObj);
    console.log(result);
    if (result.status === "error") {
      return dispatch(replyTicketFail(result.message));
    }

    dispatch(fetchSingleTicket(_id));

    dispatch(replyTicketSuccess(result.message));
  } catch (error) {
    console.log(error.message);
    dispatch(replyTicketFail(error.message));
  }
};
//Actions for closing ticket
export const closeTicket = (_id) => async (dispatch) => {
  dispatch(closeTicketLoading());
 // console.log(_id);
  try {
    const result = await updateTicketStatusClosed(_id);
    if (result.status === "error") {
      return dispatch(closeTicketFail(result.message));
    }

    dispatch(fetchSingleTicket(_id));

    dispatch(closeTicketSuccess("Ticket has been closed!"));
  } catch (error) {
    console.log("At dispatch");
    dispatch(closeTicketFail(error.message));
  }
};

//Actions for opening ticket
export const openTicket = (_id) => async (dispatch) => {
  dispatch(openTicketLoading());
  try {
    const result = await updateTicketStatusOpen(_id);
    if (result.status === "error") {
      console.log("error to open ticket");
      return dispatch(openTicketFail(result.message));
    }

    dispatch(fetchSingleTicket(_id));

    dispatch(openTicketSuccess("Ticket has been reopened!"));
  } catch (error) {
    console.log(error.message);
    dispatch(openTicketFail(error.message));
  }
};
//Actions for inprogress ticket
export const inProgressTicket = (_id) => async (dispatch) => {
  dispatch(inProgressTicketLoading());
  try {
    const result = await updateTicketStatusInProgress(_id);
    if (result.status === "error") {
      return dispatch(inProgressTicketFail(result.message));
    }

    dispatch(fetchSingleTicket(_id));

    dispatch(inProgressTicketSuccess("Ticket status has been set to In Progress!"));
  } catch (error) {
    console.log(error.message);
    dispatch(inProgressTicketFail(error.message));
  }
};
//Actions for UnderReview ticket
export const underReviewTicket = (_id) => async (dispatch) => {
  dispatch(underReviewTicketLoading());
  try {
    const result = await updateTicketStatusUnderReview(_id);
    if (result.status === "error") {
      return dispatch(underReviewTicketFail(result.message));
    }

    dispatch(fetchSingleTicket(_id));

    dispatch(
      underReviewTicketSuccess("Ticket status has been set to Under Customer Review!")
    );
  } catch (error) {
    console.log(error.message);
    dispatch(underReviewTicketFail(error.message));
  }
};
